import FJAIVideoGeneratorRight from '../view/FJAIVideoGeneratorRight.jsx';
import useLocalStore from '../../../../hooks/useLocalStore.js';
import { useSelector, useDispatch } from 'react-redux';
import { useCallback, useMemo } from 'react';
import FJRequirementsUtil from '../../../../util/FJRequirementsUtil.js';
import FJActionAIVideoGenerator from '../../../../redux/action/FJActionAIVideoGenerator.js';
import { setSliceIsDraggingFileAction, setSliceSelectListAction } from '../../../../redux/slices/FJSliceCommon.js';
import FJActionCommon from '../../../../redux/action/FJActionCommon.js';
import { AI_GENERATOR_VIDEO_TAB_TYPE } from '../../../../config/dataConfig/FJAIVideoGeneratorData.js';
import FJConstant from '../../../../constants/FJConstant.js';

const FJAIVideoGeneratorRightContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const headerTabIndex = useSelector(state => state.common.headerTabIndex);
    const currentGenerateStatus = useSelector(state => state.AIVideoGenerator.currentGenerateStatus);
    const generatingVideoNum = useSelector(state => state.AIVideoGenerator.generatingVideoNum);
    const isShowGeneratingVideoNum = useSelector(state => state.AIVideoGenerator.isShowGeneratingVideoNum);
    const historyList = useSelector(state => state.common.historyList);
    const sortType = useSelector(state => state.AIVideoGenerator.sortType);
    const tabIndex = useSelector(state => state.AIVideoGenerator.tabIndex);
    const currentTackId = useSelector(state => state.AIVideoGenerator.currentTackId);
    const showHistoryNum = FJRequirementsUtil.getSortHistoryList(historyList, sortType).length;
    const creditNumber = useSelector(state => state.common.creditNumber);
    const videoEffectPresetList = useSelector(state => state.AIVideoGenerator.videoEffectPresetList);

    // 模型选择器相关状态
    const isModelPickerVisible = useSelector(state => state.AIVideoGenerator.isModelPickerVisible);
    const currentModel = useSelector(state => state.AIVideoGenerator.currentModel);

    const currentInfo = useMemo(() => {
        return historyList.find(item => item.eventId === currentTackId) || {};
    }, [historyList, currentTackId]);

    const getCredit = () => {
        dispatch(FJActionCommon.getCreditsAction());
    };

    const setSortType = type => {
        if (type !== sortType) {
            dispatch(setSliceSelectListAction([]));
        }
        dispatch(FJActionAIVideoGenerator.setSortTypeAction(type));
    };

    // 模型选择器相关actions
    const onModelChange = useCallback(
        model => {
            dispatch(FJActionAIVideoGenerator.changeModelAction(model));
        },
        [dispatch],
    );

    const onModelPickerToggle = useCallback(
        isVisible => {
            dispatch(FJActionAIVideoGenerator.toggleModelPickerVisibilityAction(isVisible));
        },
        [dispatch],
    );

    const uploadFile = useCallback(
        file => {
            dispatch(FJActionAIVideoGenerator.uploadFileAction(file));
        },
        [dispatch],
    );

    const setIsDraggingFile = useCallback(
        value => {
            if (tabIndex === AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO) {
                dispatch(setSliceIsDraggingFileAction(value));
            }
        },
        [dispatch, tabIndex],
    );

    const reGenerate = useCallback(() => {
        // 如果有currentInfo.id，使用它；否则传递null，让retryTaskAction使用store中的参数
        const taskId = currentInfo.id || null;
        dispatch(FJActionAIVideoGenerator.retryTaskAction(taskId));
    }, [dispatch, currentInfo]);

    const jumpHistory = () => {
        dispatch(FJActionCommon.setHeaderTabIndexAction(FJConstant.HISTORY));
    };

    const _onUse = info => {
        dispatch(FJActionAIVideoGenerator.usePresetInVideoEffectAction(info));
    };

    const bkImgUrl = useMemo(() => {
        if (currentInfo.generationType === 'ev') {
            const { effectInfo } = currentInfo;
            const { effectOriginalUrlList } = effectInfo;
            return effectOriginalUrlList.length === 1 ? effectOriginalUrlList[0] : '';
        } else if (currentInfo.generationType === 'iv') {
            return currentInfo?.originalUrl?.split(',')[0] ?? '';
        } else {
            // 文生视频没有原始图片显示
            return null;
        }
    }, [currentInfo]);

    return (
        <FJAIVideoGeneratorRight
            currentGenerateStatus={currentGenerateStatus}
            getCredit={getCredit}
            imgUrl={bkImgUrl}
            generationType={currentInfo.generationType}
            headerTabIndex={headerTabIndex}
            generatingVideoNum={generatingVideoNum}
            isShowGeneratingVideoNum={isShowGeneratingVideoNum}
            sortType={sortType}
            setSortType={setSortType}
            showHistoryNum={showHistoryNum}
            uploadFile={uploadFile}
            setIsDraggingFile={setIsDraggingFile}
            reGenerate={reGenerate}
            jumpHistory={jumpHistory}
            creditNumber={creditNumber}
            videoEffectPresetList={videoEffectPresetList}
            tabIndex={tabIndex}
            onUse={_onUse}
            isModelPickerVisible={isModelPickerVisible}
            currentModel={currentModel}
            onModelChange={onModelChange}
            onModelPickerToggle={onModelPickerToggle}
            model={currentInfo.model}
        />
    );
};
export default FJAIVideoGeneratorRightContainer;
